$ = require('jquery')

GroupRegistrationCtrl = ($scope ,$location ,$filter ,flash ,formDialogService ,formFileReaderService ,groupDataService ,groupRegisDataService ,$ngConfirm ) ->
  # default data
  angular.element(document.body).css 'min-width', 0
  maxFileUploadSize = 5000000
  $scope.group = {
    type: '0'
  }

  defDirS3 = {
    prefixCover: 'images/group/cover/'
    prefixAvatar: 'images/group/avatar/'
  }

  $scope.isSubmitting = false
  $scope.policyDatas = groupDataService.getPolicyData()
  $scope.coverPhoto = undefined
  $scope.croppedCoverPhoto = ''
  $scope.avatarPhoto = undefined
  $scope.croppedAvatarPhoto = ''
  $scope.croppedCoverPhotoBlob = ''
  $scope.croppedAvatarPhotoBlob = ''


  # cover url
  groupRegisDataService.createS3ImageURL(defDirS3.prefixCover).then (resp) ->
    $scope.preDataCover = resp.data
  # avatar url
  groupRegisDataService.createS3ImageURL(defDirS3.prefixAvatar).then (resp) ->
    $scope.preDataAvatar = resp.data

  $scope.choosePolicy = (policy) ->
    $scope.group.type = policy

  $scope.chooseCover = ->
    openFileDialog( (file, fileLocation) ->
      formFileReaderService.loadImageOrientation('coverPhoto', file).then (data) ->
        $scope.coverData = data
        $scope.coverPhoto = data.base64Data
        $('.crop-image-modal').modal 'show'
    )

  $scope.chooseAvatar = ->
    openFileDialog( (file, fileLocation) ->
      formFileReaderService.loadImageOrientation('avatar', file).then (data) ->
        $scope.avatarData = data
        $scope.avatarPhoto = data.base64Data
        $('.crop-icon-modal').modal 'show'
    )

  $scope.cancelCropModal = ->
    $scope.coverPhoto = ''
    $scope.croppedCoverPhoto = ''
    $('#coverPhoto').attr('src', '')
    $('.crop-image-modal').modal 'hide'
    return

  $scope.submitCropModal = ->
    $('.crop-image-modal').modal 'hide'
    return

  $scope.cancelCropIconModal = ->
    $scope.avatarPhoto = ''
    $scope.croppedAvatarPhoto = ''
    $('#avatar').attr('src', '')
    $('.crop-icon-modal').modal 'hide'
    return

  $scope.submitCropIconModal = ->
    $('.crop-icon-modal').modal 'hide'
    return

  $scope.btnCancelClick = ->
    $location.path('/groups')

  $scope.submit = (group) ->
    $scope.isSubmitting = true

    coverData = {
      coverFile: $scope.croppedCoverPhotoBlob
      url: $scope.preDataCover.url
      fields: $scope.preDataCover.fields
    }

    avatarData = {
      coverFile: $scope.croppedAvatarPhotoBlob
      url: $scope.preDataAvatar.url
      fields: $scope.preDataAvatar.fields
    }
    groupRegisDataService.createGroup($scope.group , coverData , avatarData)
      .then (data) ->
        if data == 'success'
          flash.success data
          $scope.isSubmitting = false
          $location.path('/groups')

      , (data) ->
        if data?.data.code is 'error.name_already_taken'
          flash.error $filter('translate')('NAME_DUPLICATED')
        else
          flash.error $filter('translate')('API_ERROR')
        $scope.isSubmitting = false

  isNotValidSizeFile = (file) ->
    file.size > maxFileUploadSize

  openFileDialog = (callback) ->
    options = {
      accept : 'image/*'
    }
    formDialogService._open(options , (file,fileLocation) ->
      if isNotValidSizeFile(file)
        $ngConfirm('Image size is more than ' + maxFileUploadSize + ' bytes')
        return
      callback(file,fileLocation)
    )


GroupRegistrationCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
  'flash'
  'formDialogService'
  'formFileReaderService'
  'groupDataService'
  'groupRegisDataService'
  '$ngConfirm'
]

module.exports = GroupRegistrationCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/group-registration-controller.coffee